/**
 * What to do with a presence id restored from storage once the server has
 * answered who this user is.
 *
 * The saved id gives chat and presence a fast first render, but it is only a
 * copy: one saved while the app talked to another environment, or before an
 * account change, keys every chat to someone who is in none of them (your own
 * messages drawn as someone else's, unread counts that never clear).
 *
 * Returns the id to switch to, `null` to drop the saved one (the server has no
 * contact for this user, so the terms gate has to run), or `undefined` to keep
 * it.
 */
export function reconcileStoredPresenceId(
  stored: string,
  server: { exists: boolean; contact: { contactPresenceId?: string | null } | null },
): string | null | undefined {
  if (!server.exists) return null
  const id = server.contact?.contactPresenceId
  if (!id || id === stored) return undefined
  return id
}
